const headers = {
    name: "MRN",
    components: [
        {
            type: "search",
            name: "search",
            placeholder: "Search",
            value: "",
        },
        {
            type: "filter",
            name: "supplier",
            allowClear: true,
            showSearch: true,
            filterOption: false,
            placeholder: "Supplier",
            api: "get-all-suppliers",
            value: null,
            options: null,
        },
        {
            type: "range",
            name: "date",
            value: {
                start: "",
                end: "",
            },
        },
        {
            type: "add",
            path: "/app/purchases/mrn/add",
        },
    ],
    navigate: {
        tabs: [
            {
                name: "LPO",
                path: "/app/purchases",
            },
            {
                name: "GRN",
                path: "/app/purchases/grn",
            },
            {
                name: "Voucher",
                path: "/app/purchases/voucher",
            },
            {
                name: "Returns",
                path: "/app/purchases/returns",
            },
            {
                name: "Debit Notes",
                path: "/app/purchases/debit-notes",
            },
            {
                name: "MRN",
                path: "",
            },
        ],
    },
};

export default headers;